import * as React from 'react';
import { useState, useEffect } from 'react';
import { Box, Stack, Typography, IconButton, Collapse, Card, CardContent, Divider } from '@mui/material';
import { ChevronRight, ChevronLeft } from '@mui/icons-material';
import SectionCard from '../layout/SectionCard';
import news from '../../models/news';
import helpers from '../../helpers/common';

export default function NewsWidget() {
    const [newsItems, setNewsItems] = useState([]);
    const [expanded, setExpanded] = useState(() => {
        // Сохраняем состояние в localStorage
        const saved = localStorage.getItem('newsWidgetExpanded');
        return saved !== null ? saved === 'true' : true;
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        news.getLatest(5)
            .then((data) => {
                console.log('[NewsWidget] Received data:', data);
                if (data && Array.isArray(data)) {
                    setNewsItems(data);
                } else if (data) {
                    // Если пришел объект, а не массив
                    console.warn('[NewsWidget] Expected array, got:', typeof data);
                    setNewsItems([]);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error('[NewsWidget] Error loading news:', err);
                setLoading(false);
            });
    }, []);

    const handleToggle = () => {
        const newExpanded = !expanded;
        setExpanded(newExpanded);
        localStorage.setItem('newsWidgetExpanded', String(newExpanded));
    };

    // Всегда показываем виджет, даже если новостей нет или идет загрузка
    // Но показываем кнопку для открытия/закрытия

    return (
        <>
            {/* Кнопка для открытия, когда виджет свернут */}
            {!expanded && (
                <Box
                    sx={{
                        position: 'fixed',
                        right: 0,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 1001,
                    }}
                >
                    <IconButton
                        onClick={handleToggle}
                        sx={{
                            bgcolor: 'background.paper',
                            boxShadow: 3,
                            borderRadius: '8px 0 0 8px',
                            '&:hover': {
                                bgcolor: 'background.default',
                            },
                        }}
                    >
                        <ChevronLeft />
                    </IconButton>
                </Box>
            )}
            <Box
                sx={{
                    position: 'fixed',
                    right: expanded ? 0 : -400,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: 400,
                    maxHeight: '80vh',
                    zIndex: 1000,
                    transition: 'right 0.3s ease-in-out',
                    boxShadow: expanded ? 3 : 0,
                }}
            >
                <SectionCard
                    sx={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: expanded ? '8px 0 0 8px' : 0,
                    }}
                >
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{ p: 2, pb: 1 }}
                    >
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                            News
                        </Typography>
                        <Stack direction="row" spacing={0.5}>
                            <IconButton
                                size="small"
                                onClick={handleToggle}
                                sx={{ p: 0.5 }}
                            >
                                {expanded ? <ChevronRight /> : <ChevronLeft />}
                            </IconButton>
                        </Stack>
                    </Stack>
                <Divider />
                <Box
                    sx={{
                        overflowY: 'auto',
                        flex: 1,
                        px: 2,
                        py: 1,
                    }}
                >
                    <Collapse in={expanded}>
                        {loading ? (
                            <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                                Loading...
                            </Typography>
                        ) : newsItems.length === 0 ? (
                            <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                                No news available
                            </Typography>
                        ) : (
                            <Stack spacing={2}>
                                {newsItems.map((item) => (
                                    <Card
                                        key={`news-${item.id}`}
                                        variant="outlined"
                                        sx={{
                                            '&:hover': {
                                                boxShadow: 2,
                                            },
                                        }}
                                    >
                                        <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
                                            <Stack spacing={1}>
                                                <Typography
                                                    variant="subtitle2"
                                                    sx={{
                                                        fontWeight: 700,
                                                        lineHeight: 1.3,
                                                    }}
                                                >
                                                    {item.title}
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                    sx={{
                                                        whiteSpace: 'pre-wrap',
                                                        wordBreak: 'break-word',
                                                        lineHeight: 1.5,
                                                    }}
                                                >
                                                    {item.content}
                                                </Typography>
                                                <Typography
                                                    variant="caption"
                                                    color="text.secondary"
                                                    sx={{ fontSize: '0.7rem' }}
                                                >
                                                    {helpers.getDate(item.created)} {helpers.getTime(item.created)}
                                                </Typography>
                                            </Stack>
                                        </CardContent>
                                    </Card>
                                ))}
                            </Stack>
                        )}
                    </Collapse>
                </Box>
            </SectionCard>
        </Box>
        </>
    );
}

